import { useEffect } from 'react';
import { filterWidgetEvent } from '@client/foundation/shared/utils/filter-widget-event';
import { WidgetPayload } from '@client/widgets/widget.types';
import { statsFieldMap } from './trading-stats.config';
import { useWidget } from '@client/widgets/widget.hook';
import { useWindow } from '@client/window/window.hook';

export const useTradingStatsEvents = () => {
  const { openWidget$ } = useWidget();
  const { openWindow } = useWindow();

  useEffect(() => {
    const subscription = openWidget$()
      .pipe(filterWidgetEvent<WidgetPayload, 'Stats'>('Stats'))
      .subscribe(({ data }) => {
        openWindow({
          type: 'Stats',
          componentProps: {
            statsFieldMap,
            data
          }
        });
      });

    return () => {
      subscription.unsubscribe();
    };
  }, []);
};
